import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useQuery } from 'react-query';
import {
    findUserByEmail,
    getRegionalPayments,
    searchPayment
} from "../../../../../api/apiServices";
import Pagination from '../../../../../services/Pagination';
import toast, { Toaster } from 'react-hot-toast'
import AuthContext from "../../../../../context/AuthProvider";
import jwt_decode from "jwt-decode";

const RegionalPaymentTransactions = () => {

    const { auth } = useContext(AuthContext)
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/regional_payment_transactions";

    const [search, setSearch] = useState(false);
    const [payment, setPayment] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(20);

    const [pf_number, setPFNumber] = useState("");
    const [mobile_number, setMobileNumber] = useState("");
    const [first_name, setFirstName] = useState("");
    const [last_name, setLastName] = useState("");

    const decoded = auth?.accessToken
        ? jwt_decode(auth.accessToken)
        : undefined

    const email = decoded?.UserInfo?.email || []

    const {
        data: userRegion,
    } = useQuery(['userRegion', email], () => findUserByEmail(email), {
        onSuccess: async (res) => {
            if (res.status === false) {
                toast.error(res.message)
                return false
            } else {
                return true
            }
        },
        onError: async (err) => { 
            toast.error(err.message)
        }
    });

    let regional_code = userRegion?.region_code


    const {
        isLoading,
        isError,
        error,
        data: regPaymts
    } = useQuery(['regPaymts', regional_code], () => getRegionalPayments(regional_code), {
        select: data => data.sort((a, b) => b.id - a.id)
    });

    let total_payments = regPaymts?.length

    const handleSearch = async (e) => {
        e.preventDefault();
        const searchData = {
            "pf_number": pf_number,
            "mobile_number": mobile_number,
            "first_name": first_name,
            "last_name": last_name,
        }
        try {
            await searchPayment(searchData).then((res) => {
                if (res.length > 0) {
                    setPayment(res)
                    setPFNumber("");
                    setMobileNumber("");
                    setFirstName("");
                    setLastName("");
                    setSearch(true)
                } else {
                    toast.info("No Payment found for member")
                    setSearch(false)
                }
            }).catch((err) => {
                toast.error("Provide at least one search parameter ")
                return false
            })
        } catch (err) {
            toast.error(err)
        }
    }
    const handleCancel = () => {
        setPFNumber("");
        setMobileNumber("");
        setFirstName("");
        setLastName("");
        setSearch(false);
        navigate(from, { replace: true });
    }

    let currentPosts = []
    const indexOfLastPage = currentPage * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    if (!search) {
        currentPosts = regPaymts?.slice(indexOfFirstPage, indexOfLastPage);
    } else {
        currentPosts = payment?.slice(indexOfFirstPage, indexOfLastPage);
    }

    let searchContent = (
        <form onSubmit={handleSearch} >
            <div className="form-group row">
                <div className="col-sm-2">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="PF Number"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setPFNumber(e.target.value)}
                        value={pf_number}
                    />
                </div>
                <div className="col-sm-2">
                    <input
                        className="form-control"
                        type="text"
                        // style={{ textTransform: "uppercase" }}
                        placeholder="Mobile Number"
                        onChange={(e) => setMobileNumber(e.target.value)}
                        value={mobile_number}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="FirstName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setFirstName(e.target.value)}
                        value={first_name}
                    />
                </div>
                <div className="col-sm-3">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="LastName"
                        style={{ textTransform: "uppercase" }}
                        onChange={(e) => setLastName(e.target.value)}
                        value={last_name}
                    />
                </div>
                <button
                    type="submit"
                    className="btn btn-success "
                > <i className="fa fa-search"></i> Search Member</button>
            </div>

        </form>
    )



    let content
    if (isLoading) {
        content = <p>Loading Payment Transactions...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content =
            currentPosts && currentPosts?.length <= 0 ? (
                <div className="table-responsive lg">
                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <td style={{ fontSize: "20px", fontWeight: "700", color: "#000", textAlign: "center" }}>
                                    There are no regional payments(s)
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (

                <div className="table-responsive lg">
                    <table className='table table-borderless table-striped'>
                        <thead>
                            <tr>
                                <th scope="col" style={{ textAlign: 'center' }} >#</th>
                                <th scope="col" style={{ textAlign: "center" }}>Year</th>
                                <th scope="col" style={{ whiteSpace: 'nowrap' }}>PF Number</th>
                                <th scope="col" style={{ whiteSpace: 'normal' }}>Name</th>
                                <th scope="col" style={{ whiteSpace: 'normal', textAlign: "center" }}>Payment Date</th>
                                <th scope="col" style={{ whiteSpace: 'normal', textAlign: "center" }}>Receipt Number</th>
                                <th scope="col" style={{ whiteSpace: 'normal', textAlign: "right" }}>Amount Paid</th>
                                <th scope="col" style={{ textAlign: "center" }}>ACTION</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPosts?.map((paymt, index) =>
                                <tr key={paymt.id}>
                                    <td style={{ textAlign: 'center' }}>{postPerPage * (currentPage - 1) + index + 1}</td>
                                    <td style={{ textAlign: 'center' }}>{paymt?.year}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{paymt?.pf_number}</td>
                                    <td style={{ whiteSpace: 'nowrap' }}>{paymt?.fullname}</td>
                                    <td style={{ textAlign: 'center' }}>{paymt?.payment_date}</td>
                                    <td style={{ textAlign: 'center' }}>{paymt?.receipt_number}</td>
                                    <td style={{ textAlign: 'right' }}>{paymt?.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    <td style={{ whiteSpace: 'nowrap', textAlign: "center" }}>
                                        <div style={{ display: 'inline-block' }}>
                                            <Link to={`/view_regional_payment/${paymt?.pf_number}`} className="small"><i className='fa fa-eye'></i> view</Link>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </tbody >
                    </table >
                </div>
            )
    }

    return (
        <>
            <section className="content-header">
                <Toaster toastOptions={{ position: "top-center" }} />
                <h1>Payment Transactions - {total_payments}</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            {searchContent}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                <div>
                                    <Link className="btn btn-success" to="/payments_by_period"><i className='fa fa-eye'></i>&nbsp; &nbsp;Period Payment</Link>&nbsp; &nbsp;
                                    <Link className="btn btn-success" to="/payments_by_month"><i className='fa fa-eye'></i>&nbsp; &nbsp;Monthly Payment</Link>&nbsp; &nbsp;
                                    <Link className="btn btn-success" to="/payments_by_mode"><i className='fa fa-eye'></i>&nbsp; &nbsp;Payments By Mode</Link>
                                </div><br />

                                {content}
                            </div>
                            <div className="panel-footer">
                                {regPaymts && !search ? (
                                    <Pagination
                                        data={regPaymts}
                                        postPerPage={postPerPage}
                                        currentPage={currentPage}
                                        setCurrentPage={setCurrentPage}
                                        setPostPerPage={setPostPerPage}
                                    />
                                ) : (
                                    <div className="search-group">
                                        <button
                                            type="submit"
                                            className="btn btn-danger "
                                            onClick={handleCancel}
                                        > <i className="fa fa-search"></i> Cancel</button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="box-footer"></div>
                </div>
            </section>
        </>
    )
}

export default RegionalPaymentTransactions;


